import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Input, Button, message, Card, Spin, DatePicker, Row, Col } from 'antd';
import { EditOutlined, ArrowLeftOutlined, DatabaseOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useViewServerQuery, useEditServerMutation } from '../store/api';

export default function EditarServidor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { data: serverData, isLoading } = useViewServerQuery(id);
  const [editServer, { isLoading: saving }] = useEditServerMutation();

  useEffect(() => {
    if (serverData?.estadoservidores) {
      const sv = serverData.estadoservidores;
      form.setFieldsValue({
        ...sv,
        proximopago: sv.proximopago ? dayjs(sv.proximopago, 'YYYY-MM-DD') : null,
      });
    }
  }, [serverData, form]);

  const onFinish = async (values) => {
    const payload = { ...values, id, proximopago: values.proximopago?.format('YYYY-MM-DD') || '' };
    try {
      await editServer(payload).unwrap();
      message.success('Servidor actualizado');
      navigate('/lista');
    } catch {
      message.error('Error al actualizar');
    }
  };

  if (isLoading) {
    return (
      <div className="page-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" tip="Cargando..." />
      </div>
    );
  }

  if (!serverData?.estadoservidores && !isLoading) {
    return <div className="page-container" style={{ textAlign: 'center', paddingTop: 80, color: '#64748b' }}>No se pudieron cargar los datos.</div>;
  }

  return (
    <div className="page-container fade-in">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title"><EditOutlined style={{ marginRight: 8 }} />Editar Servidor</h1>
          <div className="page-subtitle">ID: {id}</div>
        </div>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/lista')} style={{ borderRadius: 8 }}>Volver</Button>
      </div>
      <Card bordered={false} style={{ borderRadius: 12, maxWidth: 700 }}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item label="Nombre" name="nombre" rules={[{ required: true }]}><Input /></Form.Item>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="IP" name="ip" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item label="Cliente" name="cliente" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Disco Total" name="disco" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item label="Espacio Libre" name="espaciolibre" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Carga" name="carga" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}>
              <Form.Item
                label="Próximo Pago"
                name="proximopago"
                rules={[{ required: true }]}
                extra={(() => {
                  const p = String(serverData?.estadoservidores?.proveedor || '').toUpperCase();
                  if (p.includes('CONTABO')) {
                    return 'Contabo: use «Sync Contabo» en la lista (cron nocturno).';
                  }
                  if (p.includes('HETZNER') || p.includes('HEZTNER')) {
                    return 'Hetzner: precio y próximo pago desde API Cloud (cron nocturno / Sync Hetzner).';
                  }
                  return undefined;
                })()}
              >
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#94a3b8', marginTop: 12, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.5px' }}>Credenciales WHM (opcional)</div>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Usuario WHM" name="whm_user"><Input placeholder="root" /></Form.Item></Col>
            <Col span={12}><Form.Item label="Token API WHM" name="whm_api_token"><Input.Password placeholder="Token API" /></Form.Item></Col>
          </Row>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#94a3b8', marginTop: 12, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.5px' }}><DatabaseOutlined style={{ marginRight: 6 }} />Credenciales MySQL (opcional)</div>
          <Row gutter={16}>
            <Col span={8}><Form.Item label="Usuario MySQL" name="mysql_user"><Input placeholder="root" /></Form.Item></Col>
            <Col span={8}><Form.Item label="Password MySQL" name="mysql_pass"><Input.Password placeholder="Password" /></Form.Item></Col>
            <Col span={8}><Form.Item label="Puerto MySQL" name="mysql_port"><Input placeholder="3306" type="number" /></Form.Item></Col>
          </Row>
          <Form.Item label="Descripción operativa" name="descripcion_detallada"
            extra="Servicios que presta, APIs expuestas y contenido general (formato lista con •)">
            <Input.TextArea rows={6} placeholder="• Rol: ...&#10;• Servicios internos: ...&#10;• Expone: ...&#10;• Contenido: ..." />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving} block
              style={{ borderRadius: 8, fontWeight: 600, height: 44, background: 'linear-gradient(135deg, #845adf, #6c3fc5)', border: 'none' }}>
              Guardar Cambios
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
